import React from 'react';
import BoxReserver from './BoxReserver';
import BoxController from './BoxController';
import CameraStream from './CameraStream';

function UserHotelPanel({ boxes, onReservationSuccess }) {
  return (
    <div className="row g-2 mb-5 user-panel-grid">
      <div className="col-lg-3 col-md-6">
        <div className="card home-card square-box h-100">
          <div className="card-body p-3 d-flex flex-column">
            <h5 className="card-title mb-3">User View</h5>
            <p className="text-muted mb-3 flex-grow-1">Reserve one of the boxes available in this hotel.</p>
            {boxes.length > 0 ? (
              <div className="d-flex flex-wrap gap-2">
                {boxes.map((box) => (
                  <span key={box.DHTBOXid} className="badge bg-light text-dark px-3 py-2">
                    Box {box.DHTBOX_id}
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-muted mb-0">No boxes are available for reservation here right now.</p>
            )}
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="square-box-wrapper reservation-box-wrapper">
          <BoxReserver userId="1" onReservationSuccess={onReservationSuccess} />
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="square-box-wrapper control-box-wrapper">
          <BoxController boxes={boxes} />
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="square-box-wrapper">
          <CameraStream boxes={boxes} />
        </div>
      </div>
    </div>
  );
}

export default UserHotelPanel;
